import { fetchSuggestedQuotations, updateSuggestedQuotation, applySuggestedQuotations } from '../../../entities/player';

export const scope = 'SUGGESTED_QUOTATION';

export function fetchSuggestedQuotationsPlayers(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.suggestedQuotations;

        if (!widget.info.isFetching)
            dispatch(fetchSuggestedQuotations(payload, scope));
    };
}

export function updateSuggestedQuotationsPlayers(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.suggestedQuotations;

        if (!widget.info.isFetching)
            dispatch(updateSuggestedQuotation(payload, scope));
    };
}

export function applySuggestedQuotationsPlayers(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.suggestedQuotations;

        if (!widget.info.isFetching)
            return dispatch(applySuggestedQuotations(payload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/onSite/suggestedQuotations/index.js